export const useChatBot = () => {
  const isVisible = useState<boolean>("show-chatbot", () => true)

  return { isVisible }
}
